<template>
  <div class="leading-link" :style="leadingLinkSizeStyle()" @click="goTo(to)">
    <span>
      <slot />
      <div class="leading-arrow" :style="leadingArrowSizeStyle()" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: () => ''
    },
    size: {
      type: String,
      default: () => '24'
    }
  },
  methods: {
    goTo(to) {
      this.$router.push(to)
    },
    leadingLinkSizeStyle() {
      return {
        height: `${this.size}px`,
        fontSize: `${this.size}px`
      }
    },
    leadingArrowSizeStyle() {
      return {
        borderWidth: `${this.size / 3}px 0 ${this.size / 3}px ${this.size / 2}px`,
        marginLeft: `${this.size / 3}px`
      }
    }
  }
}
</script>

<style>
.leading-link {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(117, 117, 117);
  cursor: pointer;
}

.leading-link span:after {
  width: 0;
  height: 2px;
  display: block;
  content: '';
  background: rgb(117, 117, 117);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.leading-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent transparent transparent rgb(117, 117, 117);
}

@media screen and (min-width: 1024px) {
  .leading-link:hover span:after {
    width: 100%;
  }
}
</style>
